export default __webpack_public_path__ + "static/media/sancerre.f13b6bd0.png";